import { render, staticRenderFns } from "./express.vue?vue&type=template&id=462278bd"
import script from "./express.vue?vue&type=script&lang=js"
export * from "./express.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462278bd')) {
      api.createRecord('462278bd', component.options)
    } else {
      api.reload('462278bd', component.options)
    }
    module.hot.accept("./express.vue?vue&type=template&id=462278bd", function () {
      api.rerender('462278bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/express.vue"
export default component.exports